const NewsList2018 = [
    {
        dt: "2018",
        my: "",
        link: "#hudco",
        title: "HUDCO Design Awards 2018",
        desc: ""
    },
    {
        dt: "2018",
        my: "",
        link: "#cmti",
        title: "MoU with CMTI",
        desc: ""
    },
    {
        dt: "2018",
        my: "",
        link: "#ceeri",
        title: "MoU with CSIR-CEERI",
        desc: ""
    },
    {
        dt: "2018",
        my: "",
        link: "https://iittp.ac.in/mou-gww",
        title: "MOU with GW&WA Department",
        desc: ""
    },
    {
        dt: "2018",
        my: "",
        link: "https://iittp.ac.in/newsletter",
        title: "Newsletter",
        desc: ""
    },
    {
        dt: "2018",
        my: "",
        link: "/campus-updates",
        title: "Campus Updates",
        desc: ""
    },
    {
        dt: "2018",
        my: "",
        link: "#moucsir",
        title: "MoU with CSIR-SERC",
        desc: ""
    },
    {
        dt: "2018",
        my: "",
        link: "/mou",
        title: "MoU with Venusgeo/7iq",
        desc: ""
    },
    {
        dt: "2018",
        my: "",
        link: "#SummerInternship",
        title: "Summer Internship",
        desc: ""
    },
    {
        dt: "2018",
        my: "",
        link: "#SmartIndia",
        title: "Smart India Hackathon",
        desc: ""
    }
];


export default NewsList2018;